module.exports = __webpack_public_path__ + "media/images/communities/logos/ao15-ec1786bbf28763a82d0c7503bb9a9724.png";